// Thu Mar 27 06:04:36 GMT 2025

import * as models from "../crm-web-api-models"

export enum ComplianceDataQuestionnaireProp {
	ComplianceDataCustomerId = 'complianceData.customer.id',
	ComplianceDataCustomerPersonFirstName = 'complianceData.customer.person.firstName',
	ComplianceDataCustomerPersonLastName = 'complianceData.customer.person.lastName',
	ComplianceDataCustomerPersonName = 'complianceData.customer.person.name',
	CreatedBy = 'createdBy',
	CreationTime = 'creationTime',
	FullyRegistered = 'fullyRegistered',
	Id = 'id',
	ModificationTime = 'modificationTime',
	ModifiedBy = 'modifiedBy',
	QuestionnaireId = 'questionnaire.id',
	QuestionnaireQuestionnaireType = 'questionnaire.questionnaireType',
	UserApprovalApprovalDate = 'userApproval.approvalDate',
	UserApprovalApprovedByLoginName = 'userApproval.approvedBy.loginName',
	UserApprovalStatus = 'userApproval.status'
}

export type ComplianceDataQuestionnairePropComplianceDataCustomerId = {
	[ComplianceDataQuestionnaireProp.ComplianceDataCustomerId] : number | null
}
export type ComplianceDataQuestionnairePropComplianceDataCustomerPersonFirstName = {
	[ComplianceDataQuestionnaireProp.ComplianceDataCustomerPersonFirstName] : string | null
}
export type ComplianceDataQuestionnairePropComplianceDataCustomerPersonLastName = {
	[ComplianceDataQuestionnaireProp.ComplianceDataCustomerPersonLastName] : string | null
}
export type ComplianceDataQuestionnairePropComplianceDataCustomerPersonName = {
	[ComplianceDataQuestionnaireProp.ComplianceDataCustomerPersonName] : string | null
}
export type ComplianceDataQuestionnairePropCreatedBy = {
	[ComplianceDataQuestionnaireProp.CreatedBy] : models.UserDto
}
export type ComplianceDataQuestionnairePropCreationTime = {
	[ComplianceDataQuestionnaireProp.CreationTime] : number | null
}
export type ComplianceDataQuestionnairePropFullyRegistered = {
	[ComplianceDataQuestionnaireProp.FullyRegistered] : boolean | null
}
export type ComplianceDataQuestionnairePropId = {
	[ComplianceDataQuestionnaireProp.Id] : number
}
export type ComplianceDataQuestionnairePropModificationTime = {
	[ComplianceDataQuestionnaireProp.ModificationTime] : number | null
}
export type ComplianceDataQuestionnairePropModifiedBy = {
	[ComplianceDataQuestionnaireProp.ModifiedBy] : models.UserDto
}
export type ComplianceDataQuestionnairePropQuestionnaireId = {
	[ComplianceDataQuestionnaireProp.QuestionnaireId] : number | null
}
export type ComplianceDataQuestionnairePropQuestionnaireQuestionnaireType = {
	[ComplianceDataQuestionnaireProp.QuestionnaireQuestionnaireType] : 'COMPLIANCE' | 'AML' | 'EPA' | 'FULL_CUSTOMER_REGISTRATION' | 'ADDITIONAL_REGISTRATION' | 'PRODUCT' | null
}
export type ComplianceDataQuestionnairePropUserApprovalApprovalDate = {
	[ComplianceDataQuestionnaireProp.UserApprovalApprovalDate] : number | null
}
export type ComplianceDataQuestionnairePropUserApprovalApprovedByLoginName = {
	[ComplianceDataQuestionnaireProp.UserApprovalApprovedByLoginName] : string | null
}
export type ComplianceDataQuestionnairePropUserApprovalStatus = {
	[ComplianceDataQuestionnaireProp.UserApprovalStatus] : 'PENDING' | 'IN_PROGRESS' | 'REJECTED' | 'APPROVED' | null
}


export type ComplianceDataQuestionnaire = 
	ComplianceDataQuestionnairePropComplianceDataCustomerId & 
	ComplianceDataQuestionnairePropComplianceDataCustomerPersonFirstName & 
	ComplianceDataQuestionnairePropComplianceDataCustomerPersonLastName & 
	ComplianceDataQuestionnairePropComplianceDataCustomerPersonName & 
	ComplianceDataQuestionnairePropCreatedBy & 
	ComplianceDataQuestionnairePropCreationTime & 
	ComplianceDataQuestionnairePropFullyRegistered & 
	ComplianceDataQuestionnairePropId & 
	ComplianceDataQuestionnairePropModificationTime & 
	ComplianceDataQuestionnairePropModifiedBy & 
	ComplianceDataQuestionnairePropQuestionnaireId & 
	ComplianceDataQuestionnairePropQuestionnaireQuestionnaireType & 
	ComplianceDataQuestionnairePropUserApprovalApprovalDate & 
	ComplianceDataQuestionnairePropUserApprovalApprovedByLoginName & 
	ComplianceDataQuestionnairePropUserApprovalStatus

export const COMPLIANCE_DATA_QUESTIONNAIRE_PROPERTY_NAMES = Object.freeze([ComplianceDataQuestionnaireProp.ComplianceDataCustomerId, ComplianceDataQuestionnaireProp.ComplianceDataCustomerPersonFirstName, ComplianceDataQuestionnaireProp.ComplianceDataCustomerPersonLastName, ComplianceDataQuestionnaireProp.ComplianceDataCustomerPersonName, ComplianceDataQuestionnaireProp.CreatedBy, ComplianceDataQuestionnaireProp.CreationTime, ComplianceDataQuestionnaireProp.FullyRegistered, ComplianceDataQuestionnaireProp.Id, ComplianceDataQuestionnaireProp.ModificationTime, ComplianceDataQuestionnaireProp.ModifiedBy, ComplianceDataQuestionnaireProp.QuestionnaireId, ComplianceDataQuestionnaireProp.QuestionnaireQuestionnaireType, ComplianceDataQuestionnaireProp.UserApprovalApprovalDate, ComplianceDataQuestionnaireProp.UserApprovalApprovedByLoginName, ComplianceDataQuestionnaireProp.UserApprovalStatus])

export type ComplianceDataQuestionnaireTab = 
	ComplianceDataQuestionnairePropId & 
	ComplianceDataQuestionnairePropComplianceDataCustomerId & 
	ComplianceDataQuestionnairePropComplianceDataCustomerPersonFirstName & 
	ComplianceDataQuestionnairePropComplianceDataCustomerPersonLastName

export const COMPLIANCE_DATA_QUESTIONNAIRE_TAB_PROPERTY_NAMES = Object.freeze([ComplianceDataQuestionnaireProp.Id, ComplianceDataQuestionnaireProp.ComplianceDataCustomerId, ComplianceDataQuestionnaireProp.ComplianceDataCustomerPersonFirstName, ComplianceDataQuestionnaireProp.ComplianceDataCustomerPersonLastName])

export type ComplianceDataQuestionnaireHistoryTab = 
	ComplianceDataQuestionnairePropId & 
	ComplianceDataQuestionnairePropComplianceDataCustomerId & 
	ComplianceDataQuestionnairePropComplianceDataCustomerPersonFirstName & 
	ComplianceDataQuestionnairePropComplianceDataCustomerPersonLastName

export const COMPLIANCE_DATA_QUESTIONNAIRE_HISTORY_TAB_PROPERTY_NAMES = Object.freeze([ComplianceDataQuestionnaireProp.Id, ComplianceDataQuestionnaireProp.ComplianceDataCustomerId, ComplianceDataQuestionnaireProp.ComplianceDataCustomerPersonFirstName, ComplianceDataQuestionnaireProp.ComplianceDataCustomerPersonLastName])

export type ComplianceDataQuestionnaireHeader = 
	ComplianceDataQuestionnairePropId & 
	ComplianceDataQuestionnairePropComplianceDataCustomerId & 
	ComplianceDataQuestionnairePropComplianceDataCustomerPersonName & 
	ComplianceDataQuestionnairePropQuestionnaireQuestionnaireType

export const COMPLIANCE_DATA_QUESTIONNAIRE_HEADER_PROPERTY_NAMES = Object.freeze([ComplianceDataQuestionnaireProp.Id, ComplianceDataQuestionnaireProp.ComplianceDataCustomerId, ComplianceDataQuestionnaireProp.ComplianceDataCustomerPersonName, ComplianceDataQuestionnaireProp.QuestionnaireQuestionnaireType])

export type ComplianceDataQuestionnaireInformation = 
	ComplianceDataQuestionnairePropId & 
	ComplianceDataQuestionnairePropComplianceDataCustomerPersonName & 
	ComplianceDataQuestionnairePropCreatedBy & 
	ComplianceDataQuestionnairePropCreationTime & 
	ComplianceDataQuestionnairePropModificationTime & 
	ComplianceDataQuestionnairePropModifiedBy & 
	ComplianceDataQuestionnairePropUserApprovalStatus & 
	ComplianceDataQuestionnairePropUserApprovalApprovalDate & 
	ComplianceDataQuestionnairePropUserApprovalApprovedByLoginName & 
	ComplianceDataQuestionnairePropFullyRegistered & 
	ComplianceDataQuestionnairePropComplianceDataCustomerId & 
	ComplianceDataQuestionnairePropQuestionnaireId & 
	ComplianceDataQuestionnairePropQuestionnaireQuestionnaireType

export const COMPLIANCE_DATA_QUESTIONNAIRE_INFORMATION_PROPERTY_NAMES = Object.freeze([ComplianceDataQuestionnaireProp.Id, ComplianceDataQuestionnaireProp.ComplianceDataCustomerPersonName, ComplianceDataQuestionnaireProp.CreatedBy, ComplianceDataQuestionnaireProp.CreationTime, ComplianceDataQuestionnaireProp.ModificationTime, ComplianceDataQuestionnaireProp.ModifiedBy, ComplianceDataQuestionnaireProp.UserApprovalStatus, ComplianceDataQuestionnaireProp.UserApprovalApprovalDate, ComplianceDataQuestionnaireProp.UserApprovalApprovedByLoginName, ComplianceDataQuestionnaireProp.FullyRegistered, ComplianceDataQuestionnaireProp.ComplianceDataCustomerId, ComplianceDataQuestionnaireProp.QuestionnaireId, ComplianceDataQuestionnaireProp.QuestionnaireQuestionnaireType])
